import {
  Edit,
  SimpleForm,
  BooleanInput,
  DateField,
  Labeled,
} from "react-admin";
import { Divider } from "@mui/material";

import {
  sanitizeServiceResources,
} from "./ServiceResourcesInput";
import ServiceTemplateTitle from "./ServiceTemplateTitle";
import useUpdateWithValidation from "../common/useUpdateWithValidation";
import FormContainer from "../common/FormContainer";
import ServiceTemplateFields from "./fields";

const ServiceTemplateEdit = () => {
  const save = useUpdateWithValidation("ServiceTemplate", {
    transform: sanitizeServiceResources,
  });

  return (
    <Edit title={<ServiceTemplateTitle />} transform={sanitizeServiceResources}>
      <SimpleForm onSubmit={save}>
        <ServiceTemplateFields />

        <Divider style={{ marginBottom: "3em" }} />

        <FormContainer>
          <BooleanInput
            source="archived"
            helperText="archivierte Vorlagen können nicht mehr für neue Service-Buchungen ausgewählt werden"
          />
        </FormContainer>

        <Divider style={{ marginBottom: "3em" }} />

        <Labeled>
          <DateField source="createdAt" showTime />
        </Labeled>
        <Labeled>
          <DateField source="updatedAt" showTime />
        </Labeled>
      </SimpleForm>
    </Edit>
  );
};

export default ServiceTemplateEdit;
